import { lazy } from "react";
import type { RouteObject } from "react-router";

const MeIndex = lazy(() => import("@/app/(main)/me/page"));
const Preferences = lazy(() => import("@/app/(main)/me/preferences/page"));
const Security = lazy(() => import("@/app/(main)/me/security/page"));
const Following = lazy(() => import("@/app/(main)/me/following/page"));
const Notifications = lazy(() => import("@/app/(main)/me/notifications/page"));

export const meRoutes: RouteObject[] = [
  { index: true, Component: MeIndex },
  { path: "preferences", Component: Preferences },
  { path: "security", Component: Security },
  { path: "following", Component: Following },
  { path: "notifications", Component: Notifications },
];
